export default "__VITE_ASSET__CdU7xgkg__"